import styled from "styled-components";

const DrawerHeaderContainerWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  background-color: ${props => props.theme.drawer.header.backgroundColor};
  width: 100%;
  height: 100%;
`;

const DrawerHeaderTitleContainerWrapper = styled.div`
  margin: 1.5rem auto;
`;

const DrawerHeaderTitleWrapper = styled.span`
  font-weight: 700;
  color: ${props => props.theme.colors.textColor};
`;

const DrawerHeaderCloseContainerWrapper = styled.div`
  position: absolute;
  left: ${props => (props.position === "right" ? "unset" : "2rem")};
  right: ${props => (props.position === "left" ? "unset" : "2rem")};
  top: 1.3rem;
  cursor: pointer;

  :hover .svg-wrapper .svg-icon {
    background-color: ${props => props.theme.colors.brandColor};
  }
`;

export {
  DrawerHeaderContainerWrapper,
  DrawerHeaderTitleContainerWrapper,
  DrawerHeaderTitleWrapper,
  DrawerHeaderCloseContainerWrapper
};
